var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "no-preview-component" },
    [
      _c(_setup.ClosePreviewComponent, {
        on: { "close-viewer-event": _setup.closeViewerEvent },
      }),
      _c("span", { staticClass: "advise" }, [
        _vm._v(_vm._s(_setup.texts.mainAdvise)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }